export default __webpack_public_path__ + "static/media/images-versions-interface.tsx.2161670b.txt";